import { useTheme } from '@mui/material';
import { Theme } from '@mui/system';

import MailIconMono from './svg/mailIconMono.svg';

export enum EMlpMailIconVariant {
	Primary = 'PRIMARY',
	PrimaryVariation = 'PRIMARY_VARIATION',
	Secondary = 'SECONDARY',
	Disabled = 'DISABLED',
}

export interface IMailIconProps {
	variant?: EMlpMailIconVariant;
	size?: number;
}

const getMailIconColors = (
	variant: EMlpMailIconVariant,
	theme: Theme
): string => {
	switch (variant) {
		case EMlpMailIconVariant.Primary:
			return theme.palette.primary.main;
		case EMlpMailIconVariant.PrimaryVariation:
			return theme.palette.solutions[600];
		case EMlpMailIconVariant.Secondary:
			return theme.palette.neutral.main;
		case EMlpMailIconVariant.Disabled:
			return theme.palette.solutions[800];
	}
};

export const MailIcon = ({
	variant = EMlpMailIconVariant.Primary,
	size = 24,
}: IMailIconProps) => {
	const theme = useTheme();
	const color = getMailIconColors(variant, theme);

	return (
		<MailIconMono
			width={size}
			height={size}
			style={{ display: 'block' }}
			fill={color}
		/>
	);
};
